import React, { useState, useEffect } from 'react'
import {
  TextField,
  Button,
  Typography,
  InputLabel,
  FormControl,
  MenuItem,
  Select
} from '@material-ui/core'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import useStyles from './styles'
import 'react-datepicker/dist/react-datepicker.css'
import axios from 'axios'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import Autocomplete from '@mui/material/Autocomplete'
import {
  API_URL,
  SelectCategory,
  VehicleVersion,
  Motor,
  Car,
  UpdateSuccess,
  SelectColorCode,
  ColorCode,
  ColorCodeName,
  Percent,
  Volume,
  Version,
  Total,
  DashBoard,
  URL,
  Close,
  Quantity
} from '../../constants/actionTypes'
import uuid from 'react-uuid'
import { NumericFormat } from 'react-number-format'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import { styled } from '@mui/material/styles'

const FormViewColorMixing = () => {
  // const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)
  const [openImage, setOpenImage] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
    setOpenImage(false)
  }
  const loginSuccess = JSON.parse(localStorage.getItem('colorMixingHipic'))

  const API = axios.create({
    baseURL: API_URL
  })
  let data = useLocation()
  const location = useLocation()
  const myQuery = location.search
  const id = myQuery.split('=')[1]
  const navigate = useNavigate()
  // const loginSuccess = JSON.parse(localStorage.getItem('colorMixing'))
  // if (!loginSuccess) {
  //   navigate(URL + '/')
  // }
  const [colorCodeInfoList, setColorCodeInfoList] = useState([
    { colorCode: '', colorName: '', percent: 0, volume: 0, total: 0 }
  ])
  const [dataColors, setDataColors] = useState([])
  const [dataColorChilds, setDataColorChilds] = useState([])
  const [buttonActive1, setButtonActive1] = useState(false)
  const [buttonActive2, setButtonActive2] = useState(false)

  const [listCategory, setListCategory] = useState([])
  const [listColorCode, setListColorCode] = useState([''])
  const [listColorName, setListColorName] = useState([''])
  const [selectTypeClick, setSelectTypeClick] = useState('car')
  const [quantity, setQuantity] = useState(0)
  const [postData, setPostData] = useState({
    id: uuid(),
    type: '',
    category: '',
    nameCode: '',
    colorCode: '',
    colorCodeList: [],
    files: '',
    version: '',
    volume: '',
    vehicleName: '',
    content: [],
    info: ''
  })

  const classes = useStyles()
  const updateJson = (jsonData) => API.post('/newhipic/ColorMixing', jsonData)

  const handleClick = () => {
    localStorage.removeItem('colorMixingHipic')
    //alert('Logout Successfully!!')

    navigate(URL)
    navigate(0)
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    let CategoryRight = ''

    let newDate = new Date()
    let date = newDate.getDate()
    let month = newDate.getMonth() + 1
    let year = newDate.getFullYear()
    const data = {
      id: postData.id,
      category: CategoryRight,
      nameCode: postData.nameCode.trim(),
      type: postData.type,
      colorCode: postData.colorCode.trim(),
      version: postData.version.trim(),
      volume: postData.volume,
      vehicleName: postData.vehicleName.trim(),
      content: postData.content,
      info: postData.info,
      createDate: date + '-' + month + '-' + year
    }
    const dataEdit = dataColors.filter((item) => item.id !== id)

    dataEdit.push(data)
    updateJson(dataEdit)
    setOpen(true)
    setTimeout(() => {
      navigate(URL + '/dashboard')
    }, 3000)
  }

  const handleChange = (e) => {
    const { name, value } = e.target

    setPostData({ ...postData, [name]: value })
  }
  const handleChangeQuantity = (e) => {
    const { name, value } = e.target

    setQuantity(value)
  }
  const handleChangeCategory = (e) => {
    setQuantity(0)
    let arrayColorCode = []
    let arrayColorName = []
    const dataColorCodes = dataColors.filter(
      (item) => item.category == e.target.value
    )
    let index = 0,
      newArr = []
    const length = dataColorCodes.length // to get length of array
    function findDuplicates(arr) {
      for (let i = 0; i < length - 1; i++) {
        for (let j = i + 1; j < length; j++) {
          if (arr[i].nameCode === arr[j].nameCode) {
            newArr[index] = arr[i].nameCode
            index++
          }
        }
      }
      return newArr
    }
    var t = findDuplicates(dataColorCodes)

    console.log(dataColorCodes)
    dataColorCodes.map((items) => {
      arrayColorCode.push({ label: items.colorCode, id: items.id })
      if (t.length > 0) {
        t.map((findDup) => {
          if (findDup == items.nameCode) {
            arrayColorName.push({
              label: items.nameCode + ' - ' + items.colorCode,
              id: items.id
            })
          } else {
            // if(items.nameCode)
            const checkExit = arrayColorName.find(
              (u) => u.label === items.nameCode
            )
            console.log(arrayColorName)

            if (!t.includes(items.nameCode)) {
              if (checkExit === undefined) {
                arrayColorName.push({
                  label: items.nameCode,
                  id: items.id
                })
              }
            }
          }
        })
      } else {
        arrayColorName.push({
          label: items.nameCode,
          id: items.id
        })
      }
    })

    setPostData({
      ...postData,
      category: e.target.value,
      colorCodeList: arrayColorCode,
      version: '',
      volume: '',
      vehicleName: ''
    })

    setListColorCode(arrayColorCode)
    setListColorName(arrayColorName)
  }
  const handleChangeColorCode = (e) => {
    let vehicleName = ''
    let version = ''
    let volume = 0
    let files = ''
    let nameCode = ''
    let content = []
    const dataColorCodes = dataColors.filter(
      (item) => item.category == postData.category
    )
    dataColorCodes.map((items) => {
      if (items.colorCode === e.target.value) {
        vehicleName = items.vehicleName
        version = items.version
        volume = items.volume
        content = items.content
        files = items.files
        nameCode = items.nameCode
      }
    })

    setPostData({
      ...postData,
      colorCode: e.target.value,
      vehicleName,
      version,
      volume,
      content,
      files,
      nameCode
    })
    // setListColorCode(arrayColorCode)
  }

  const handleInfoColorCodeChange = (e, newValue) => {
    let vehicleName = ''
    let version = ''
    let volume = 0
    let files = ''
    let nameCode = ''
    let content = []
    const dataColorCodes = dataColors.filter(
      (item) => item.category == postData.category
    )
    dataColorCodes.map((items) => {
      if (items.colorCode === newValue.label) {
        vehicleName = items.vehicleName
        version = items.version
        volume = items.volume
        content = items.content
        files = items.files
        nameCode = items.nameCode
      }
    })

    setPostData({
      ...postData,
      colorCode: newValue.label,
      vehicleName,
      version,
      volume,
      content,
      files,
      nameCode
    })
  }

  const handleInfoColorNameChange = (e, newValue) => {
    let nameCodeNew = ''
    var nameCodeValue = newValue.label.split('-')
    if (nameCodeValue.length > 1) {
      nameCodeNew = nameCodeValue[0].trim()
    } else {
      nameCodeNew = newValue.label
    }

    let vehicleName = ''
    let version = ''
    let volume = 0
    let files = ''
    let nameCode = ''
    let colorCode = ''
    let content = []
    const dataColorCodes = dataColors.filter(
      (item) => item.category == postData.category
    )
    dataColorCodes.map((items) => {
      if (
        items.nameCode === nameCodeNew &&
        items.category === postData.category
      ) {
        vehicleName = items.vehicleName
        version = items.version
        volume = items.volume
        content = items.content
        files = items.files
        nameCode = items.nameCode
        colorCode = items.colorCode
      }
    })

    setPostData({
      ...postData,
      nameCode: newValue.label,
      vehicleName,
      version,
      volume,
      content,
      files,
      nameCode,
      colorCode
    })
  }

  const [inputValue, setInputValue] = useState([])

  const handleInfoColorCodeChange2 = (e, newValue) => {
    const list = [...inputValue]

    // const newNumbers = [
    //   ...list.slice(0),
    //   newValue.toUpperCase(),
    //   ...list.slice(0)
    // ]
  }

  const getColorById = async (id, dataEditColor) => {
    const dataEdit = dataEditColor.filter((item) => item.id == id)
    setColorCodeInfoList(dataEdit[0].content)
    setPostData({
      ...postData,

      id: dataEdit[0].id,
      type: dataEdit[0].type,
      category: dataEdit[0].category,
      createDate: dataEdit[0].createDate,
      info: dataEdit[0].info,
      nameCode: dataEdit[0].nameCode,
      files: dataEdit[0].files,
      colorCode: dataEdit[0].colorCode,
      vehicleName: dataEdit[0].vehicleName,
      version: dataEdit[0].version,
      volume: dataEdit[0].volume,
      content: dataEdit[0].content
    })
    // setDataColorEdit(dataEdit)
  }
  const selectTypeHandleClick = (event) => {
    let buttonActive1 = false
    let buttonActive2 = false
    if (event == 'motor') {
      buttonActive1 = false
      buttonActive2 = true
    } else {
      buttonActive1 = true
      buttonActive2 = false
    }

    setButtonActive1(buttonActive1)
    setButtonActive2(buttonActive2)
    setPostData({
      id: uuid(),
      type: '',
      category: '',
      nameCode: '',
      colorCode: '',
      colorCodeList: [],
      version: '',
      volume: '',
      vehicleName: '',
      content: [],
      info: ''
    })
    setSelectTypeClick(event)
  }
  const getAllColors = async () => {
    let arrayData = []
    let arrayCategory = []
    let dataColorMixingPath = ''
    // if (location.state.rePrint) {
    dataColorMixingPath = `${API_URL}/uploadshipic/src3/dataColorMixingHipic.json`
    axios
      .get(dataColorMixingPath, {
        crossdomain: true
      })
      .then((res) => {
        const dataColorMixing = res.data
        dataColorMixing.map((items) => {
          if (selectTypeClick === items.type) {
            arrayCategory.push(items.category)
          }
        })
        dataColorMixing.map((items) => {
          if (selectTypeClick === items.type) {
            arrayData.push({
              id: items.id,
              type: items.type,
              category: items.category,
              colorCode: items.colorCode,
              nameCode: items.nameCode,
              vehicleName: items.vehicleName,
              content: items.content,
              info: items.info,
              version: items.version,
              files: items.files,
              volume: items.volume,
              createDate: items.createDate
            })
          }
        })

        const namesArr = arrayCategory.filter(function (elem, pos) {
          return arrayCategory.indexOf(elem) == pos
        })

        setListCategory(namesArr)
        setDataColors(arrayData)

        //  getColorById(id, arrayData)
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    getAllColors()
  }, [selectTypeClick, quantity])

  return (
    <Paper className={classes.paper} style={{ backgroundColor: 'transparent' }}>
      <form
        encType='multipart/form-data'
        autoComplete='off'
        noValidate
        className={`${classes.root} ${classes.form}`}
        onSubmit={handleSubmit}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <div className={classes.viewColorLeft}>
                {postData && postData.files ? (
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      height: '100px'
                    }}
                  >
                    <img
                      onClick={() => setOpenImage(true)}
                      src={API_URL + '/' + postData.files}
                      style={{
                        margin: '0 auto',
                        maxWidth: '50%',
                        cursor: 'pointer'
                      }}
                    />{' '}
                  </FormControl>
                ) : (
                  ''
                )}
                <FormControl
                  className={classes.formControl}
                  fullWidth
                  style={{ marginTop: '0px' }}
                >
                  <div className={classes.wrapButtonView}>
                    <Button
                      className={classes.SelectType}
                      style={{
                        backgroundColor:
                          buttonActive1 == true ? 'white' : '#b5131b',
                        color: buttonActive1 == true ? '#000' : '#fff'
                      }}
                      variant='contained'
                      color='primary'
                      size='large'
                      type='button'
                      fullWidth
                      onClick={() => selectTypeHandleClick('car')}
                    >
                      {Car}
                    </Button>
                    <Button
                      style={{
                        backgroundColor:
                          buttonActive2 == true ? 'white' : '#b5131b',
                        color: buttonActive2 == true ? '#000' : '#fff'
                      }}
                      className={classes.SelectType}
                      sx={{
                        '&:active': {
                          background: 'black'
                        }
                      }}
                      variant='contained'
                      color='primary'
                      size='large'
                      type='button'
                      fullWidth
                      onClick={() => selectTypeHandleClick('motor')}
                    >
                      {Motor}
                    </Button>
                  </div>
                </FormControl>
                <div className='wrapSelect'>
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel id='demo-simple-select-label'>
                      {SelectCategory} *
                    </InputLabel>

                    <Select
                      labelId='demo-simple-select-label'
                      id='demo-simple-select'
                      value={postData.category}
                      label={SelectCategory}
                      required
                      // error={postData.Location == '' ? 'error' : null}
                      onChange={(e) => handleChangeCategory(e)}
                    >
                      <MenuItem key={'lo'} value=''>
                        {SelectCategory}
                      </MenuItem>
                      {listCategory.map((item, index) => (
                        <MenuItem key={item + index + 'lo'} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* <FormControl fullWidth className={classes.formControl}>
                    <InputLabel id='SelectColorCode-simple-select-label'>
                      {SelectColorCode} *
                    </InputLabel>

                    <Select
                      labelId='SelectColorCode-simple-select-label'
                      id='SelectColorCode-simple-select'
                      value={postData.colorCode}
                      label={SelectColorCode}
                      required
                      onChange={(e) => handleChangeColorCode(e)}

                      // error={postData.Location == '' ? 'error' : null}
                    >
                      <MenuItem key={'lo'} value=''>
                        {SelectColorCode}
                      </MenuItem>
                      {postData.colorCodeList.map((item, index) => (
                        <MenuItem key={item + index + 'co'} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                  <FormControl fullWidth className={classes.formControl2}>
                    <Autocomplete
                      options={listColorCode}
                      value={postData.colorCode}
                      // key={option}

                      onChange={(event: any, newValue: string | null) => {
                        handleInfoColorCodeChange(event, newValue)
                      }}
                      // inputValue={''}
                      onInputChange={(event, newInputValue) => {
                        handleInfoColorCodeChange2(event, newInputValue)
                      }}
                      renderInput={(params) => (
                        <TextField
                          style={{
                            width: '100%',
                            flexGrow: 1,
                            padding: '2px 0px',
                            margin: '0px'
                          }}
                          className='labelColorCode'
                          name='colorCode'
                          label={SelectColorCode}
                          {...params}
                          variant='outlined'
                          fullWidth
                        />
                      )}
                    ></Autocomplete>
                  </FormControl>
                </div>
                <div className='wrapSelect'>
                  {/* <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      className={classes.fileInput}
                      name='version'
                      variant='outlined'
                      label={ColorCodeName}
                      fullWidth
                      value={postData.nameCode || ''}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormControl> */}
                  <FormControl fullWidth className={classes.formControl2}>
                    <InputLabel id='demo-simple-select-label'>
                      {ColorCodeName} *
                    </InputLabel>
                    <Autocomplete
                      options={listColorName}
                      value={postData.nameCode}
                      // key={option}

                      onChange={(event: any, newValue: string | null) => {
                        handleInfoColorNameChange(event, newValue)
                      }}
                      // inputValue={''}
                      // onInputChange={(event, newInputValue) => {
                      //   handleInfoColorCodeChange2(event, newInputValue)
                      // }}

                      renderInput={(params) => (
                        <TextField
                          style={{
                            width: '100%',
                            flexGrow: 1,
                            padding: '2px 0px',
                            margin: '0px'
                          }}
                          className='labelColorCode'
                          name='version'
                          label={ColorCodeName}
                          {...params}
                          variant='outlined'
                          fullWidth
                        />
                      )}
                    ></Autocomplete>
                  </FormControl>
                </div>
                <div className='wrapInput'>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      className={classes.fileInput}
                      name='vehicleName'
                      variant='outlined'
                      label={VehicleVersion}
                      fullWidth
                      disabled
                      value={postData.vehicleName || ''}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormControl>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={8}
              sx={{
                fontSize: { xs: '20px' },
                overflowX: { xs: 'scroll' }
              }}
            >
              <div className={classes.displayResult}>
                <div style={{ backgroundColor: '#67707F' }}>
                  <Typography
                    variant='h6'
                    style={{
                      fontWeight: '700',
                      fontSize: '25px',
                      color: '#fff',
                      textAlign: 'center',
                      background: '#b5131b'
                    }}
                  >
                    {postData.nameCode}
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table aria-label='simple table'>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className={classes.headingText}
                            align='center'
                          >
                            STT
                          </TableCell>
                          <TableCell
                            className={classes.headingText}
                            align='center'
                          >
                            {ColorCode}
                          </TableCell>
                          <TableCell
                            className={classes.headingText}
                            align='center'
                          >
                            {ColorCodeName}
                          </TableCell>
                          <TableCell
                            className={classes.headingText}
                            align='center'
                          >
                            {Volume} (g)
                          </TableCell>
                          <TableCell
                            className={classes.headingText}
                            align='center'
                          >
                            {Total} (g)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody
                        style={{
                          minHeight: '100px',
                          background: '#fff',
                          width: '100%',
                          display: 'inline-masonry'
                        }}
                      >
                        {postData.content !== '' &&
                          postData.content?.map((row, index) => {
                            let newVolume,
                              newTotal = 0

                            if (quantity && quantity != '' && quantity > 0) {
                              newVolume = row.volume * quantity
                              newTotal = row.total * quantity
                            } else {
                              newVolume = row.volume
                              newTotal = row.total
                            }

                            return (
                              <TableRow
                                key={row.colorCode}
                                sx={{
                                  '&:last-child td, &:last-child th': {
                                    border: 0
                                  }
                                }}
                                style={{ padding: '8px' }}
                              >
                                <TableCell
                                  align='center'
                                  component='th'
                                  scope='row'
                                  style={{ padding: '8px' }}
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  align='center'
                                  scope='row'
                                  style={{ padding: '8px' }}
                                >
                                  {row.colorCode}
                                </TableCell>
                                <TableCell
                                  align='center'
                                  style={{ padding: '8px' }}
                                >
                                  {row.colorName}
                                </TableCell>
                                <TableCell
                                  align='center'
                                  style={{ padding: '8px' }}
                                >
                                  {parseFloat(newVolume).toFixed(2)} (g)
                                </TableCell>
                                <TableCell
                                  align='center'
                                  style={{ padding: '8px' }}
                                >
                                  {parseFloat(newTotal).toFixed(2)} (g)
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        {postData.content == '' ? (
                          <>
                            <TableRow
                              key='noRow1'
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0
                                }
                              }}
                            >
                              <TableCell component='th' scope='row'></TableCell>
                              <TableCell align='right' scope='row'></TableCell>
                              <TableCell align='right'></TableCell>
                              <TableCell align='right'></TableCell>
                              <TableCell align='right'></TableCell>
                              <TableCell align='right'></TableCell>
                            </TableRow>
                            <TableRow
                              key='noRow'
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0
                                }
                              }}
                            >
                              <TableCell component='th' scope='row'></TableCell>
                              <TableCell align='right' scope='row'></TableCell>
                              <TableCell align='right'></TableCell>
                              <TableCell align='right'></TableCell>
                              <TableCell align='right'></TableCell>
                              <TableCell align='right'></TableCell>
                            </TableRow>
                          </>
                        ) : (
                          ''
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>

              <div className='moreButton' style={{ textAlign: 'center' }}>
                <Link
                  to={{
                    pathname: URL + '/dashboard/'
                  }}
                >
                  <Button className={classes.buttonLink} type='button'>
                    {DashBoard}
                  </Button>
                </Link>
                {loginSuccess ? (
                  <Button
                    style={{ marginLeft: '10px' }}
                    className={classes.buttonLink}
                    type='button'
                    onClick={handleClick}
                  >
                    Đăng Xuất
                  </Button>
                ) : (
                  ''
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </form>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {UpdateSuccess}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{Close}</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openImage}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-image'>
            {postData && postData.files ? (
              <img
                src={API_URL + '/' + postData.files}
                style={{
                  margin: '0 auto',
                  marginTop: '0px',
                  maxWidth: '100%',
                  width: '100%',
                  cursor: 'pointer'
                }}
              />
            ) : (
              ''
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{Close}</Button>
        </DialogActions>
      </Dialog>
      <div className={classes.fixedForm}>
        <div className='wrapFixedForm'>
          <NumericFormat
            className={classes.fileInput}
            name='quantity'
            variant='outlined'
            label={Quantity}
            fullWidth
            value={quantity || ''}
            onChange={(e) => handleChangeQuantity(e)}
            customInput={TextField}
            valueIsNumericString
          />
        </div>
      </div>
    </Paper>
  )
}

export default FormViewColorMixing
